import { MapLayerId, SurveyModuleId, WorkspaceId } from "../../core";
import { RoleV1 } from "../types.generated";
import { unsafeRoleV1 } from "./internal";

export const superuserRoleV1: RoleV1 = unsafeRoleV1("superuser");

export function registeredRoleV1(workspaceId: WorkspaceId): RoleV1 {
  return unsafeRoleV1(`registered:${workspaceId}`);
}

export function activeRoleV1(workspaceId: WorkspaceId): RoleV1 {
  return unsafeRoleV1(`active:${workspaceId}`);
}

export function activeMobileRoleV1(workspaceId: WorkspaceId): RoleV1 {
  return unsafeRoleV1(`activeMobile:${workspaceId}`);
}

export function arcgisAdminRoleV1(workspaceId: WorkspaceId): RoleV1 {
  return unsafeRoleV1(`arcgisAdmin:${workspaceId}`);
}

export function userAdminRoleV1(workspaceId: WorkspaceId): RoleV1 {
  return unsafeRoleV1(`userAdmin:${workspaceId}`);
}

export function surveyViewerRoleV1(
  workspaceId: WorkspaceId,
  moduleId: SurveyModuleId
): RoleV1 {
  return unsafeRoleV1(`surveyViewer:${workspaceId}:${moduleId}`);
}

export function surveyorRoleV1(
  workspaceId: WorkspaceId,
  moduleId: SurveyModuleId
): RoleV1 {
  return unsafeRoleV1(`surveyor:${workspaceId}:${moduleId}`);
}

export function surveyDownloaderRoleV1(
  workspaceId: WorkspaceId,
  moduleId: SurveyModuleId
): RoleV1 {
  return unsafeRoleV1(`surveyDownloader:${workspaceId}:${moduleId}`);
}

export function surveyAdminRoleV1(
  workspaceId: WorkspaceId,
  moduleId: SurveyModuleId
): RoleV1 {
  return unsafeRoleV1(`surveyAdmin:${workspaceId}:${moduleId}`);
}

export function mapViewerRoleV1(
  workspaceId: WorkspaceId,
  layerId: MapLayerId
): RoleV1 {
  return unsafeRoleV1(`mapViewer:${workspaceId}:${layerId}`);
}

export function mapDownloaderRoleV1(
  workspaceId: WorkspaceId,
  layerId: MapLayerId
): RoleV1 {
  return unsafeRoleV1(`mapDownloader:${workspaceId}:${layerId}`);
}
